import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthenticationService } from '../../auth';
import { isNullOrUndefined } from 'in-time-core';
import { from, Observable, switchMap } from 'rxjs';
import { RestApiHelper } from '../../data-layer/helpers/rest-api.helper';

export const httpInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const authenticationService = inject(AuthenticationService);
  const user = authenticationService.authState?.user;

  if(isNullOrUndefined(user)) {
    return next(req);
  }

  return from(user.getIdToken()).pipe(
    switchMap((idToken) => {
      if(isNullOrUndefined(idToken)) {
        return next(req);
      }

      return next(
        req.clone({
          setHeaders: {
            'Content-Type': 'application/json; charset=utf-8',
            'accept': 'application/json; charset=utf-8',
            'X-Api-Version': RestApiHelper.getApiVersion(),
            'Authorization': `Bearer ${idToken}`,
          }
        })
      );
    })
  );
};
